<ng-container *ngIf="formPrincipal">
  <div class="card-header">
    <div class="title-section">
      <h2 class="header-title">{{ modelRecived ? 'Editar Intereses' : 'Agregar Intereses' }}</h2>
    </div>
    <div class="search-section">
      <div class="button-section">
        <button class="btn-new" mat-raised-button color="accent" appPermissionControl="P140B0002" (click)="modelRecived ? update(form.value) : create(form.value)">
          <mat-icon>save</mat-icon>
          {{ modelRecived ? 'Actualizar' : 'Guardar' }}
        </button>
        <button class="btn-cancel" type="button" mat-raised-button (click)="close()" appPermissionControl="P140B0001"><mat-icon>arrow_back</mat-icon>Cancelar</button>
      </div>
    </div>
  </div>

  <form class="mt-5" [formGroup]="form" (submit)="modelRecived ? update(form.value) : create(form.value)" appPermissionControl="P140F0001">
    <div class="form-row">
      <div class="form-field" color="accent" appearance="outline">
        <label>Variable</label>
        <input id="numVar" class="form-control" formControlName="numVar" type="number" [readonly]="modelRecived" required appPermissionControl="P140K0001" />
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Descripción</label>
        <input class="form-control" formControlName="descripcion" type="text" required appPermissionControl="P140K0002" />
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Concepto</label>
        <select class="form-control" formControlName="concepto" required appPermissionControl="P140K0003">
          <option value>-- Seleccione --</option>
          <option *ngFor="let concepto of conceptos" [value]="concepto.concepto">{{ concepto.concepto }} | {{ concepto.descripcion }}</option>
        </select>
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Calcular</label>
        <select class="form-control" formControlName="calculate" appPermissionControl="P140K0004">
          <option value="">-- Selecciona --</option>
          <option *ngFor="let item of solicitudesValores" [value]="item.iValor">
            {{ item.sEtiqueta }}
          </option>
        </select>
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Días Desde</label>
        <input class="form-control" formControlName="amortInf" type="text" required appPermissionControl="P140K0005" />
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Días Hasta</label>
        <input class="form-control" formControlName="amortSup" type="text" required appPermissionControl="P140K0006" />
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Porcentaje</label>
        <select class="form-control" formControlName="claveTasa" required appPermissionControl="P140K0007">
          <option value>-- Seleccione --</option>
          <option *ngFor="let tasa of tasas" [value]="tasa.clave">{{ tasa.clave }} | {{ tasa.descripcion }}</option>
        </select>
      </div>
    </div>
  </form>
</ng-container>
